import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Role } from "../models/role.model";
import { SelectItem } from "primeng/api";
import { ConfigService } from "src/app/services/config.service";
import { User } from "../users/models/user.model";
import { AuthenticationService } from "src/app/services/authentication.service";

@Injectable()
export class RoleService {
    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService,
        private authService: AuthenticationService,
    ) {
        this.getRoles().subscribe((items) => {
            this.setRolesList(items);
        });
    }

    roleSelectItems: SelectItem[] = [];
    rolesList: Role[] = [];
    rolesLoaded = false;

    rolesToSelectItems(roles: Role[]): SelectItem[] {
        return roles.map((item) => {
            return {
                label: item.roleName,
                value: item.roleName,
            };
        });
    }

    getRoles() {
        return this.httpClient.get<Role[]>(
            this.configService.apiBaseUrl.concat("role"),
        );
    }

    getSingleRole(roleName: string) {
        return this.httpClient.get<Role>(
            this.configService.apiBaseUrl.concat("role/", roleName),
        );
    }

    setRolesList(roles: Role[]) {
        this.rolesList.length = 0;
        this.rolesList.push(...roles);

        this.setRoleSelectItems();

        this.rolesLoaded = true;
    }

    setRoleSelectItems() {
        this.roleSelectItems.length = 0;
        this.roleSelectItems.push(...this.rolesToSelectItems(this.rolesList));
    }

    createRole(roleDto: any) {
        return this.httpClient.post<Role>(
            this.configService.apiBaseUrl.concat("Role/Create"),
            roleDto,
        );
    }

    updateRole(roleDto: Role) {
        return this.httpClient.post<Role>(
            this.configService.apiBaseUrl.concat("Role/Update/", roleDto.id),
            roleDto,
        );
    }

    deleteRole(roleId: string) {
        return this.httpClient.delete<Role>(
            this.configService.apiBaseUrl.concat("Role/Delete/", roleId),
        );
    }

    getUsersInRole(roleId: string) {
        return this.httpClient.get<User[]>(
            this.configService.apiBaseUrl.concat("Role/Users/", roleId),
        );
    }

    addToRoleList(role: Role) {
        this.rolesList.unshift(role);
        this.setRoleSelectItems();
    }

    removeRole(roleId: string) {
        const index = this.rolesList.findIndex((role) => {
            return role.id === roleId;
        });
        if (index >= 0) {
            this.rolesList.splice(index, 1);
            this.setRoleSelectItems();
        }
    }

    replaceRoleInList(roleId: string, role: Role) {
        const index = this.rolesList.findIndex((role) => {
            return role.id === roleId;
        });
        if (index >= 0) {
            this.rolesList.splice(index, 1, role);
            this.setRoleSelectItems();
        }
    }
}
